import './App.css';
import AllRoute from './components/AllRoute';

function App() {
  return (
    <>
      <AllRoute />
      {/* <div className="bg-red-500 text-white p-10 text-3xl">
        Tailwind đang chạy
      </div> */}
    </>
  );
}

export default App;